import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbMediaBreakpointsService, NbMenuService, NbSearchService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { Subject, Subscription } from 'rxjs';
import { filter, finalize, map, takeUntil } from 'rxjs/operators';
import { ConfigService } from '../../../@core/config.service';
import { LayoutService } from '../../../@core/utils';
import { DialogService } from '../../../common/service/dialog.service';
import { LeakedFileCheker } from '../../../common/tasker/leaked-file-checker';
import { Accounts } from '../../../common/util/accounts';
import { Objects } from '../../../common/util/objects';
import { SettingComponent } from '../../../pages/setting/setting.component';
import { ServerService } from '../../service/connection.service';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  public userPictureOnly: boolean = false;
  public user: any;
  public isSearch = false;
  public sidebarIsExpanded: boolean = false;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  defaultMenu = [];

  userMenu = [
    { title: 'Profile', link: '', icon: { icon: 'user', pack: 'far'}},
    { title: 'Logout', icon: 'power-outline' },
  ];

  adminMenu = [
    // { title: 'SWDB', skipLocationChange: true, icon: 'archive-outline', children: [
    //   { title: 'Product', link: 'pages/product', icon: 'cube-outline'},
    //   { title: 'Hash', link: 'pages/hash', icon: 'hash-outline'}
    // ]},
    // { title: 'Classifications', link: 'pages/classification', icon: { pack: 'fas', icon: 'cubes'} },
    // { title: 'Accounts', link: 'pages/account', icon: 'people-outline'},
    // { title: 'Companies', link: 'pages/company', icon: { icon: 'building', pack: 'far'} },
    // { title: 'Requests', skipLocationChange: true, icon: 'email-outline', children: [
    //   { title: 'Accounts', link: 'pages/request', icon: 'person-add-outline'}
    // ]},
    { title: 'Profile', link: '', icon: { icon: 'user', pack: 'far'}},
    { title: 'Logout', icon: 'power-outline' },
  ];

  public dashboardLayout: any;
  public monitoring: boolean = false;
  public selectGroup: string;
  public groups: any;
  public alert: boolean = true;
  public intervalAlert: any;
  public nowUrl: any;
  public serverOn: boolean = true;
  public dashboardLayoutSubscription: Subscription;
  public menuSubscription: Subscription;
  
  private _sendConnection: boolean = false;
  private _connectionTimer: any;

  constructor(
    private sidebarService: NbSidebarService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private configService: ConfigService,
    private router: Router,
    private serverServices: ServerService,
    private dialogService: DialogService,
    private leakedFileCheker: LeakedFileCheker,
    private nbMenuService: NbMenuService,
    private searchService: NbSearchService,
  ) {
    router.events.subscribe((d: any) => {
      if (d.url) {
        this.nowUrl = d.url;

        if (d.url !== '/pages/dashboard') {
          this.monitoring = false;
          this.changeMonitoring();
        }
      }
    });

    this.user = Accounts.getAccount();
    this.defaultMenu = this.user && this.user.permission === 'ADMIN' ? this.adminMenu : this.userMenu;

    const profileItem = this.adminMenu.find(item => item.title === 'Profile');
    if (profileItem && this.user)
      profileItem.link = `pages/account/${this.user.id}`;

    this.configService.monitoring$.subscribe((d: any) => (this.monitoring = d));
    
    // 서버상태확인
    this.getServerStatus();
    this._connectionTimer = setInterval(() => {

      if (!this._sendConnection)
        this.getServerStatus();

    }, 1000 * 60);

    this.searchService.onSearchSubmit().subscribe((data: any) => {
      this.onGlobalSearch(data);
    });
  }
  
  getServerStatus(): void {
    this._sendConnection = !this._sendConnection;
    this.serverServices.connection().pipe(finalize(() => this._sendConnection = false))
      .subscribe(
      (d: any) => {
        if (!this.serverOn) {
          this.serverOn = d.result;
          this.configService.changeServerOn(this.serverOn);
        }
      },
      (e) => {
        this.serverOn = false;
      },
    );
  }

  changuGroup(event: any): void {
    this.configService.changeMapType(event);
  }

  showAlert(): void {
    this.alert = false;
  }

  ngOnInit() {

    // 모니터링
    this.monitoring = true;
    this.changeMonitoring();

    // 센터 셀렉트박스
    this.selectGroup = 'file';
    this.groups = [
      { name: '파일', value: 'file' },
      { name: '프로젝트', value: 'project' },
      { name: '에이전트', value: 'agent' },
    ];

    // 테마변경
    this.currentTheme = this.themeService.currentTheme;

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl));

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe((themeName) => (this.currentTheme = themeName));

    // 이전 Theme 설정 불러오기
    const theme = localStorage.getItem('theme');
    if (theme) {
      this.themeService.changeTheme(theme);
    }

    // 대시보드 레이아웃 불러오기
    // this.dashboardLayout = localStorage.getItem('dashboardLayout');
    // if (this.user.permission === 'ADMIN' && !this.dashboardLayout) {
    //   this.layoutChange('homeRealtime5');
    // }

    // this.dashboardLayoutSubscription = this.configService.dashboard$.subscribe((layout) => {
    //   this.dashboardLayout = layout;
    // });

    this.menuSubscription = this.nbMenuService.onItemClick()
      .pipe(filter(({ tag }) => tag === 'header-menu'), map(({ item: { title } }) => title))
      .subscribe(title => {
        if (title === 'Logout') {
          this.logout();
        }
      });
  }

  logout() {
    const cf = this.dialogService.confirm('확인', '로그아웃 하시겠습니까?');
    cf.onClose.subscribe(
      (res) => {
        if (!res) return;
        
        this.router.navigate([`auth/logout`]);
      }
    );
  }

  changeMonitoring() {
    setTimeout(() => this.configService.changeMonitoring(this.monitoring), 500);
  }

  /**
   * 대시보드 레이아웃 변경
   * @param layout 레이아웃 (row, column)
   */
  layoutChange(layout: string) {
    this.dashboardLayout = layout;
    localStorage.setItem('dashboardLayout', this.dashboardLayout);

    if (layout === 'setting') {
      this.router.navigate([`pages/setting`]);
      return;
    }

    if (layout === 'trend') {
      this.router.navigate([`pages/trend`]);
      return;
    }

    if (layout === 'search') {
      this.router.navigate([`pages/stats`]);
      return;
    }

    this.configService.changeDashboard(layout);
    this.router.navigate([`pages/dashboard`]);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.dashboardLayoutSubscription?.unsubscribe();
    this.menuSubscription?.unsubscribe();

    if (this._connectionTimer) {
      clearInterval(this._connectionTimer);
    }
  }

  changeTheme(themeName: string) {
    localStorage.setItem('theme', themeName);
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    this.sidebarIsExpanded = !this.sidebarIsExpanded;
    return false;
  }

  get sideBarStyle() {
    return this.sidebarIsExpanded? 'auto' : '30px';
  }

  navigateHome() {
    this.configService.changeLogoClickValue('true');

    if (this.user.permission === 'ADMIN') {
      this.router.navigate([`pages/dashboard`]);
    }
    return false;
  }

  goDashboard2() {
    this.router.navigate(['pages/dashboard2']);
  }

  showSetting(): void {
    this.dialogService.open(SettingComponent, {}).onClose.subscribe((obj: any) => {
      if (obj === undefined) {
        return;
      }
    });
  }

  onGlobalSearch(event: any) {
    this.router.navigate([`pages/product`], { queryParams: { "term": event.term, "type": 'ALL', "includeDisabled": false } });
  }
}